module.exports = __webpack_public_path__ + "img/select.6a0d9433.svg";